/**
 * One-click sign-in links: `https://<demo host>/#key=<Passio API key>&to=/tour`.
 *
 * The key travels in the URL fragment, which browsers never send to servers or put in Referer
 * headers. It's read and stripped from the address bar (and the history entry) before the app
 * renders, then exchanged once through the normal `POST /api/auth/key` sign-in.
 */
let pending: string | null = null;

const KEY_PARAMS = ["key", "apiKey", "api_key"];

/** Same-origin app path only (no `//host`, no admin). */
function safePath(to: string | null): string | null {
  if (!to || !/^\/(?![/\\])[^\s]*$/.test(to) || to.startsWith("/admin")) return null;
  return to;
}

/** Call once at startup, before the router reads the URL. */
export function captureKeyLink(): void {
  if (!window.location.hash) return;
  const params = new URLSearchParams(window.location.hash.slice(1));
  const key = KEY_PARAMS.map((p) => params.get(p)?.trim()).find(Boolean);
  if (!key) return;
  const to = safePath(params.get("to"));
  for (const p of [...KEY_PARAMS, "to"]) params.delete(p);
  const rest = params.toString();
  window.history.replaceState(window.history.state, "", `${to ?? window.location.pathname + window.location.search}${rest ? `#${rest}` : ""}`);
  pending = key;
}

/** The captured key, handed out once. */
export function takeKeyLink(): string | null {
  const key = pending;
  pending = null;
  return key;
}
